// Vehicle Damage form config

import { DAMAGE_ROUTE_OPTIONS, VEHICLE_STATUS_OPTIONS, PARTY_DEALING_OPTIONS } from '../constants';

export const vehicleDamageFields = [
    {
        key: 'claimant-vehicle-damage',
        name: 'Claimant Vehicle Damage',
        fields: [
            {
                name: 'roadworthy_status',
                label: 'Vehicle Roadworthy?',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'damage_severity',
                label: 'Damage Severity',
                type: 'text',
                validation: {}
            },
            {
                name: 'damage_location_1',
                label: 'Damage Location 1',
                type: 'text',
                grouppedFields: {
                    key: 'vd_damage_location',
                    index: 0,
                    total: 4
                },
                validation: {}
            },
            {
                name: 'damage_location_2',
                label: 'Damage Location 2',
                type: 'text',
                grouppedFields: {
                    key: 'vd_damage_location',
                    index: 1,
                    total: 4,
                    firstInGroup: true,
                    addButtonLabel:"Add damage location"
                },
                validation: {}
            },
            {
                name: 'damage_location_3',
                label: 'Damage Location 3',
                type: 'text',
                grouppedFields: {
                    key: 'vd_damage_location',
                    index: 2,
                    total: 4,
                    firstInGroup: true,
                    addButtonLabel:"Add damage location"
                },
                validation: {}
            },
            {
                name: 'damage_location_4',
                label: 'Damage Location 4',
                type: 'text',
                grouppedFields: {
                    key: 'vd_damage_location',
                    index: 3,
                    total: 4,
                    firstInGroup: true,
                    addButtonLabel:"Add damage location"
                },
                validation: {}
            },
            {
                name: 'likely_total_loss',
                label: 'Likely Total Loss?',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'claimant_vehicle_value_trade',
                label: 'Claimant Vehicle Value - Trade',
                type: 'float',
                validation: {}
            },
            {
                name: 'claimant_vehicle_value_private_sale',
                label: 'Claimant Vehicle Value - Private Sale',
                type: 'float',
                validation: {}
            },
            {
                name: 'claimant_vehicle_value_retail',
                label: 'Claimant Vehicle Value - Retail',
                type: 'float',
                validation: {}
            },
            {
                name: 'vehicle_location',
                label: 'Vehicle Location',
                type: 'text',
                validation: {}
            },
            {
                name: 'damage_route',
                label: 'Damage Route',
                type: 'dropdown',
                dropdownOptions: DAMAGE_ROUTE_OPTIONS,
                validation: {}
            },
            {
                name: 'party_dealing_with_ad_claim',
                label: 'Party Dealing with AD Claim',
                type: 'dropdown',
                dropdownOptions: PARTY_DEALING_OPTIONS,
                validation: {}
            },
            {
                name: 'cho_option',
                label: 'CHO Option?',
                type: 'text',
                validation: {}
            },
            {
                name: 'damage_type',
                label: 'Damage type',
                type: 'text',
                validation: {}
            }
        ]
    },
    {
        key: 'engineer-information',
        name: 'Engineer Information',
        fields: [
            {
                name: 'instruct_engineer',
                label: 'Instruct Engineer?',
                type: 'text',
                validation: {}
            },
            {
                name: 'engineer_appointed',
                label: 'Engineer Appointed',
                type: 'text',
                validation: {}
            },
            {
                name: 'engineer_company_name',
                label: 'Engineer Company Name',
                type: 'text',
                validation: {}
            },
            {
                name: 'engineer_company_address',
                label: 'Engineer Company Address',
                type: 'text',
                validation: {}
            },
            {
                name: 'engineer_company_postcode',
                label: 'Engineer Company Post Code',
                type: 'text',
                validation: {}
            },
            {
                name: 'engineer_company_contact_nb',
                label: 'Engineer Company Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'phoneNumber'}]
            },
            {
                name: 'engineer_company_email_address',
                label: 'Engineer Company Email Address',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'email'}]
            }
        ]
    },
    {
        key: 'engineers-report',
        name: 'Engineers Report',
        fields: [
            {
                name: 'repair_valuation',
                label: 'Repair Valuation',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_labour_charge_estimation',
                label: 'Total Labour Charge Estimation',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_parts_charge_estimation',
                label: 'Total Parts Charge Estimation',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_paint_materials_charge_estimation',
                label: 'Total Paint & Materials Charge Estimation',
                type: 'float',
                validation: {}
            },
            {
                name: 'total_specialist_charge_estimation',
                label: 'Total Specialist Charge Estimation',
                type: 'float',
                validation: {}
            },
            {
                name: 'repair_duration_estimate',
                label: 'Repair Duration Estimate',
                type: 'integer',
                validation: {}
            },
            {
                name: 'engineer_name',
                label: 'Engineer Name',
                type: 'text',
                validation: {}
            },
            {
                name: 'engineer_vehicle_valuation_trade',
                label: 'Engineer Vehicle Valuation - Trade',
                type: 'float',
                validation: {}
            },
            {
                name: 'engineer_vehicle_valuation_private',
                label: 'Engineer Vehicle Valuation - Private',
                type: 'float',
                validation: {}
            },
            {
                name: 'engineer_vehicle_valuation_retail',
                label: 'Engineer Vehicle Valuation - Retail',
                type: 'float',
                validation: {}
            },
            {
                name: 'agreed_pre_accident_value',
                label: 'Agreed Pre Accident Value',
                type: 'float',
                validation: {}
            },
            {
                name: 'percentage_repair_cost_to_vehicle_value',
                label: 'Percentage Repair Cost to Vehicle Value',
                type: 'text',
                validation: {}
            },
            {
                name: 'salvage_category',
                label: 'Salvage Category',
                type: 'text',
                validation: {}
            },
            {
                name: 'salvage_value',
                label: 'Salvage Value',
                type: 'float',
                validation: {}
            },
            {
              name: 'salvage_percent',
              label: 'Salvage %',
              type: 'float',
              validation: {}
          },
            {
                name: 'raise_pav',
                label: 'Raise PAV?',
                type: 'text',
                validation: {}
            },
            {
                name: 'claimant_retaining_salvage',
                label: 'Claimant Retaining Salvage?',
                type: 'text',
                validation: {}
            },
            {
                name: 'salvage_instruction_required',
                label: 'Salvage Instruction Required?',
                type: 'text',
                validation: {}
            }
        ]
    },
    {
        key: 'repair-information',
        name: 'Repair Information',
        fields: [
            {
                name: 'instruct_repairer',
                label: 'Instruct Repairer?',
                type: 'text',
                validation: {}
            },
            {
                name: 'repairer_appointed',
                label: 'Repairer Appointed',
                type: 'text',
                validation: {}
            },
            {
                name: 'repairer_name',
                label: 'Repairer Name',
                type: 'text',
                validation: {}
            },
            {
                name: 'repairer_address',
                label: 'Repairer Address',
                type: 'text',
                validation: {}
            },
            {
                name: 'repairer_postcode',
                label: 'Repairer Post Code',
                type: 'text',
                validation: {}
            },
            {
                name: 'repairer_contact_nb',
                label: 'Repairer Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'phoneNumber'}]
            },
            {
                name: 'repairer_email_address',
                label: 'Repairer Email Address',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'email'}]
            }
        ]
    },
    {
        key: 'recovery-information',
        name: 'Recovery Information',
        fields: [
            {
                name: 'instruct_recovery',
                label: 'Instruct Recovery?',
                type: 'text',
                validation: {}
            },
            {
                name: 'recovery_appointed',
                label: 'Recovery Appointed',
                type: 'text',
                validation: {}
            },
            {
                name: 'recovery_provider_name',
                label: 'Recovery Provider Name',
                type: 'text',
                validation: {}
            },
            {
                name: 'recovery_provider_address',
                label: 'Recovery Provider Address',
                type: 'text',
                validation: {}
            },
            {
                name: 'recovery_provider_postcode',
                label: 'Recovery Provider Post Code',
                type: 'text',
                validation: {}
            },
            {
                name: 'recovery_provider_contact_nb',
                label: 'Recovery provider Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'phoneNumber'}]
            },
            {
                name: 'recovery_provider_email_address',
                label: 'Recovery Provider Email Address',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'email'}]
            }
        ]
    },
    {
        key: 'storage-information',
        name: 'Storage Information',
        fields: [
            {
                name: 'instruct_storage_provider',
                label: 'Instruct Storage Provider?',
                type: 'text',
                validation: {}
            },
            {
                name: 'storage_appointed',
                label: 'Storage Appointed',
                type: 'text',
                validation: {}
            },
            {
                name: 'storage_provider_name',
                label: 'Storage Provider Name',
                type: 'text',
                validation: {}
            },
            {
                name: 'storage_provider_address',
                label: 'Storage Provider Address',
                type: 'text',
                validation: {}
            },
            {
                name: 'storage_provider_postcode',
                label: 'Storage Provider Post Code',
                type: 'text',
                validation: {}
            },
            {
                name: 'storage_provider_contact_nb',
                label: 'Storage provider Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'phoneNumber'}]
            },
            {
                name: 'storage_provider_email_address',
                label: 'Storage Provider Email Address',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'email'}]
            }
        ]
    },
    {
        key: 'salvage-information',
        name: 'Salvage Information',
        fields: [
            {
                name: 'instruct_salvage_provider',
                label: 'Instruct Salvage Provider?',
                type: 'text',
                validation: {}
            },
            {
                name: 'salvage_appointed',
                label: 'Salvage Appointed',
                type: 'text',
                validation: {}
            },
            {
                name: 'salvage_provider_name',
                label: 'Salvage Provider Name',
                type: 'text',
                validation: {}
            },
            {
                name: 'salvage_provider_address',
                label: 'Salvage Provider Address',
                type: 'text',
                validation: {}
            },
            {
                name: 'salvage_provider_postcode',
                label: 'Salvage Provider Post Code',
                type: 'text',
                validation: {}
            },
            {
                name: 'salvage_provider_contact_nb',
                label: 'Salvage provider Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'phoneNumber'}]
            },
            {
                name: 'salvage_provider_email_address',
                label: 'Salvage Provider Email Address',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'email'}]
            }
        ]
    }
];
